import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import './Loading.css';

const Loading: React.FC = () => {
  const antIcon = <LoadingOutlined style={{ fontSize: 200 }} spin />;
  return (
    <div className="loading-container">
      <Spin indicator={antIcon} />
    </div>
  );
};

export default Loading;
